import { StringKeyValue } from '../actions/types';

interface Config {
    text: StringKeyValue;
}

interface Context {
    appType: string | null;
}

const customAppTypeConfigs: { [index: string]: Config } = {};

const CustomAppTypes = {
    NAF: 'naf',
    EIKA: 'eika',
    AGRI: 'agricard',
    LBS: 'lbs',
    isAppType: (context: Context, appType: Context['appType']): boolean => context.appType === appType,
    isNaf: (context: Context): boolean => CustomAppTypes.isAppType(context, CustomAppTypes.NAF),
    isEika: (context: Context): boolean => CustomAppTypes.isAppType(context, CustomAppTypes.EIKA),
    isAgri: (context: Context): boolean => CustomAppTypes.isAppType(context, CustomAppTypes.AGRI),
    isLbs: (context: Context): boolean => CustomAppTypes.isAppType(context, CustomAppTypes.LBS),
    isLokalbank: (context: Context): boolean =>
        !CustomAppTypes.isAgri(context) && !CustomAppTypes.isEika(context) && !CustomAppTypes.isNaf(context),
    all: (): string[] => Object.keys(customAppTypeConfigs),
    resolveConfig: (appType: string): any => customAppTypeConfigs[appType],
};

/*
    Keys definert her skal ikke inneholde suffiks (_agricard, _naf, _eika)
    Det skal kun være suffiks på keys i sitecore (eller sitecoreSimulationData.js)
*/
customAppTypeConfigs[CustomAppTypes.AGRI] = {
    text: {
        /* Override default keys */
        productName: 'Agricard',
        defaultInfoBoxText:
            'Ta kontakt med Agricard på telefon 915 05 712 hvis du har spørsmål. Vi hjelper deg gjerne!',
        cardNameGold: 'Agricard Privat',
        cardNameBusiness: 'Agricard Ansatt',
    },
};
customAppTypeConfigs[CustomAppTypes.NAF] = {
    text: {
        /* Override default keys */
        productName: 'NAF Kredittkort',
        defaultInfoBoxText:
            'Ta kontakt med Eika Kredittbank på telefon 915 03 850 eller e-post kundesenter@eika.no hvis du har spørsmål. Vi hjelper deg gjerne!',
        cardNameGold: 'NAF Xtra kort',
        ikkeKundeHeader: 'Feil ved sammenligning av fødselsdato',
        ikkeKundeText1v2: 'Fødselsnummeret brukt i BankID må passe med fødselsdato brukt i oppslag mot NAF.',
        ikkeKundeText3v2: 'Hvis du skrev feil fødselsdato i oppslag mot NAF, så må du gå tilbake dit for å endre.',
        ikkeKundeLinkText: 'Gå tilbake til kalkulatoren',
        ikkeKundeInfoBox: '{defaultInfoBoxText}',
        ikkeKundeLink: '/',
    },
};
customAppTypeConfigs[CustomAppTypes.EIKA] = {
    text: {
        /* Override default keys */
        productName: 'Eika Kredittkort',
        defaultInfoBoxText:
            'Ta kontakt med Eika Kredittbank på telefon 915 03 850 eller e-post kundesenter@eika.no hvis du har spørsmål. Vi hjelper deg gjerne!',
        cardNameGold: 'Eika Gold kredittkort',
        cardNameBusiness: 'Eika Business kredittkort',

        /* New Customer Stop Message */
        newCustomerStopHeader: 'Takk for at du ønsker kredittkort fra Eika',
        newCustomerStopText1:
            'Vi tilbyr dessverre ikke søknader på nye kort her nå. Det er kun mulig å endre kredittgrense på kort som allerede finnes.',
        newCustomerStopText2:
            'Kontakt oss hvis du mener noe er feil. Ellers håper vi å kunne tilby dette i fremtiden og ønsker deg tilbake da.',
        newCustomerStopLink: '/',
        newCustomerStopLinkText: 'Avslutt',
        newCustomerStopInfoBox: '{defaultInfoBoxText}',
    },
};

customAppTypeConfigs[CustomAppTypes.LBS] = {
    text: {
        cardNameGold: 'LOKALBANK Privat',
        cardNameBusiness: 'LOKALBANK Ansatt',
    },
};

export default CustomAppTypes;
